<template>
  <OnboardingFeatureView>
    <p>Before we tip off, let’s pick your theme</p>
    <form
      class="OnboardingThemeView__form"
      @submit.prevent="$emit('submit')"
    >
      <ThemeCarousel
        v-model="playerTheme"
        v-model:direction="direction"
        class="OnboardingThemeView__carousel"
      />
      <FormButton
        class="OnboardingThemeView__saveButton"
        type="submit"
        v-bind="{direction}"
      >
        <span :key="ctaLabel">
          {{ ctaLabel }}
        </span>
      </FormButton>
    </form>
  </OnboardingFeatureView>
</template>

<script lang="ts" setup>
import FormButton from "@/components/FormButton.vue";
import ThemeCarousel from "@/components/ThemeCarousel.vue";
import { Theme, themeMap } from "@shared/lib/constants/themes";
import { TablesInsert } from "@shared/lib/database/database.types";
import { computed, ref } from "vue";
import OnboardingFeatureView from "./OnboardingFeatureView.vue";

const player = defineModel<TablesInsert<"players">>("player", {
  required: true,
});

defineEmits<{
  submit: [],
}>();

const direction = ref<"left" | "right" | null>(null);

const playerTheme = computed({
  get () {
    return (player.value.theme || "LosAngelesLakers") as keyof typeof Theme;
  },
  set (theme: keyof typeof Theme) {
    player.value.theme = theme;
  },
});

const ctaLabel = computed(() => {
  return themeMap.get(playerTheme.value)?.slogan || "Next";
});
</script>

<style lang="scss" scoped>
.OnboardingThemeView__form {
  display: grid;
  gap: 40px;
  transition: 350ms color;
}

.OnboardingThemeView__carousel {
  padding: 16px 0;
}

.OnboardingThemeView__saveButton {
  max-width: 340px;
  margin-inline: auto;
}
</style>
